<script>
export default {
    name: "GRNDetails",

    data () {
        return {
            grnDetails: {},
            grnLines: [],
        };
    },

    computed: {
    
        totalDiscount () {
            if(!this.grnLines.length) return 0;

            return this.grnLines.map(grnL => parseFloat(grnL.discount)).reduce((sum, discount) => sum + discount);
        },
    
        totalTax () {
            if(!this.grnLines.length) return 0;

            return this.grnLines.map(grnL => parseFloat(grnL.tax)).reduce((sum, tax) => sum + tax);
        },
    
        grandTotal () {
            if(!this.grnLines.length) return 0;

            return this.grnLines.map(grnL => parseFloat(grnL.grandTotal)).reduce((sum, grandTotal) => sum + grandTotal);
        }
    },

    mounted () {
        this.fetchGRNDetails();
    },

    methods: {

        fetchGRNDetails () {
            this.$http.get(`SupplierGRN/GetSpecificGRN?GRNNO=${this.$router.currentRoute.params.GRNNO}`).then(response => {
                this.grnDetails = response.data[0];
                this.fetchGRNLines();
            });
        },

        fetchGRNLines () {
            this.$http.get(`SupplierGRN/PostedGRNDetails?GRNNO=${this.$router.currentRoute.params.GRNNO}&UserName=${this.grnDetails.userName}`)
                .then(response => {
                    this.grnLines = response.data;
                });
        },

        printReceipt(url) {
            window.open(url, 'GRN Preview', 'left=400,top=200,width=800,height=800,tollbar=0,scrollbars=1,status=0,resizable=1');
        },
        print(){
            window.print();
        }
    }
}
</script>
<template>
    <tail-base-layout>
   
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <div class="flex w-full">
            <h5 class="flex-1 font-medium">GOODS RETURN NOTE</h5>
            <div class="flex flex-1 justify-end"></div>
          </div>
        </template>
        <template v-slot:card-body>
            <tail-address-header></tail-address-header>
        <div class="flex justify-center p-2">
                <h3 class="text-center font-bold text-blue-400 border-b-2 border-blue-400">GOODS RETURN NOTE</h3>
            </div>
             <div class="flex flex-row w-full p-1">
            <div class="flex-1 px-1">
                <h4 class="font-bold text-sm">Supplier: {{ grnDetails.supplier }}</h4>
            </div> <div class="flex-1 px-1">
                <h4 class="font-bold text-sm">Date: {{ grnDetails.txnDate | dateFormat }}</h4>
            </div>
            <div class="flex-1 px-1">
               <h4 class="font-bold text-sm">Grn No: {{ grnDetails.grnNo }}</h4> 
            </div>
         
        </div>
            <div class="w-full">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="text-sm">Item</th>
                            <th class="text-sm">LPO Qty</th>
                            <th class="text-sm">Qty</th>
                            <th class="text-sm">Price</th>
                            <th class="text-sm">GRNID</th>
                            <th class="text-sm">Grand Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(grnLine, index) in grnLines" :key="index">
                            <td class="text-xs">{{ grnLine.itemName }}</td>
                            <td class="text-xs">{{ grnLine.orderedQty }}</td>
                            <td class="text-xs">{{ grnLine.qty }}</td>
                            <td class="text-xs">{{ grnLine.unitPrice }}</td>
                            <td class="text-xs">{{ grnLine.grnid }}</td>
                            <td class="text-xs">{{ grnLine.grandTotal }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex flex-row">
                <div class="w-1/4"></div>
                <div class="w-1/4">
                  <h4 class="font-bold text-center">Discount: {{ totalDiscount }}</h4>
                </div>
                <div class="w-1/4">
                  <h4 class="font-bold text-center">Tax: {{ totalTax }}</h4>
                </div>
                <div class="w-1/4">
                  <h4 class="font-bold text-center">Grand Total: {{ grandTotal }}</h4>
                </div>
            </div>
            <!-- <div class="flex md:flex-row sm:flex-col">
                <div class="w-1/2 flex flex-start">
                    <button class="btn-sm btn-info" @click.prevent="printReceipt(`/suppliers/grns/print/${grnDetails.grnNo}`)">
                        <i class="fa fa-print"></i> Preview
                    </button>
                </div>
                <div class="w-1/2 flex flex-end"></div>
            </div> -->
        </template>
        <template v-slot:card-footer>
           <div class="w-full text-right">
        
                           <router-link :to="{ name: `suppliers-dashboard.grn-list.index` }" class="btn-sm btn-danger text-sm rounded mr-6"><i class="fa fa-caret-left"></i> Back</router-link>
             <button class="btn-sm text-sm btn-primary rounded" 
                    @click.prevent="printReceipt(`/suppliers-dashboard/grn-list/print/${grnDetails.grnNo}`)">
                        <i class="fa fa-print"></i> Preview</button>
                          
           </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
